__webpack_require__.p = "%static_cdn_url%/";